@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.consent-bar {
  border-radius: 10px 10px 0 0;
  background: rgba(19, 19, 24, 0.9);
  backdrop-filter: blur(5px);
  color: white;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 80;
  bottom: 0;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
}

.consent-bar.enter {
  transform: translateY(0%);
}

.consent-bar.leave {
  transform: translateY(100%);
}

@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.enter {
  animation: enter 0.9s ease-in-out;
}
